export default function BlogCardSkeleton() {
  return (
    <div className="border-border-card mr-6 flex shrink-0 basis-[73%] animate-pulse flex-col items-start justify-start overflow-hidden rounded-lg border md:basis-[38%] lg:basis-[31.6%] xl:basis-[32%]">
      {/* Image placeholder */}
      <div className="relative aspect-[147/120] w-full rounded-t-lg bg-gray-200 xl:aspect-[5/3]"></div>

      {/* Content */}
      <div className="flex h-full w-full flex-col items-start justify-between space-y-[21px] p-4">
        <div className="w-full space-y-2">
          {/* Title */}
          <div className="h-6 w-full rounded bg-gray-200"></div>
          {/* Excerpt lines */}
          <div className="space-y-1">
            <div className="h-4 w-full rounded bg-gray-200"></div>
            <div className="h-4 w-4/5 rounded bg-gray-200"></div>
            <div className="h-4 w-3/5 rounded bg-gray-200"></div>
          </div>
        </div>

        {/* Author & Date */}
        <div className="w-full space-y-1">
          <div className="h-5 w-32 rounded bg-gray-200"></div>
          <div className="h-4 w-24 rounded bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
}

